import { render, staticRenderFns } from "./PricesTable.vue?vue&type=template&id=76bfcd75&scoped=true"
import script from "./PricesTable.vue?vue&type=script&lang=ts"
export * from "./PricesTable.vue?vue&type=script&lang=ts"
import style0 from "./PricesTable.vue?vue&type=style&index=0&id=76bfcd75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bfcd75",
  null
  
)

export default component.exports